<div class="panel panel-form panel-form-delivery" [ngClass]="{ open: open }">
  <lib-form-header [open]="open" [header]="header" [required]="required" (openChange)="open = $event"></lib-form-header>
  @if (open && form) {
    <div class="panel-content">
      <form [formGroup]="form">
        @for (mainKey of order.main; track mainKey) {
          <div class="row">
            <div class="col-12 col-xl-auto col-main-checkbox form-field-container">
              <mat-checkbox
                class="checkbox"
                [formControl]="getFormControl(mainKey)"
                (change)="clearForm(mainKey, $event.checked)"
              >
                {{ 'form.field.' + mainKey | transloco }}
              </mat-checkbox>
            </div>
            <div class="col-12 col-xl">
              <div class="row">
                @for (key of order.costs; track key) {
                  <div
                    class="col-12 col-md-6 col-xl-4 form-field-container"
                    [ngClass]="{ inactive: isInactive(mainKey + key) }"
                  >
                    <div class="form-field-label">
                      {{ 'form.field.' + mainKey + key | transloco }}
                      @if (key.includes('min') || key.includes('max')) {
                        <div
                          class="i-icon"
                          #tooltip="matTooltip"
                          [matTooltip]="'tooltip.shop.' + mainKey + key | transloco"
                          [matTooltipPosition]="'above'"
                          (click)="tooltip.toggle()"
                        >
                          <span class="i">i</span>
                        </div>
                      }
                    </div>
                    <mat-form-field class="form-field form-field-currency" [floatLabel]="'auto'">
                      <span class="currency">€</span>
                      <input
                        matInput
                        currencyMask
                        [formControlName]="mainKey + key"
                        [options]="{ align: 'left', prefix: '', thousands: '.', decimal: ',' }"
                        [readonly]="isInactive(mainKey + key)"
                      />
                    </mat-form-field>
                  </div>
                }
              </div>
              <div class="row" [ngClass]="{ inactive: isInactive(mainKey) }">
                <div class="col-12 mb-0 form-field-container">
                  <mat-checkbox class="checkbox m-0" [formControl]="getFormControl(mainKey + '_allow_pay_at')">
                    {{ 'form.field.' + mainKey + '_allow_pay_at' | transloco }}
                    <div
                      class="i-icon"
                      #tooltip="matTooltip"
                      [matTooltip]="'tooltip.shop.' + mainKey + '_allow_pay_at' | transloco"
                      [matTooltipPosition]="'above'"
                      (click)="tooltip.toggle()"
                    >
                      <span class="i">i</span>
                    </div>
                  </mat-checkbox>
                </div>
              </div>
              <div class="row row-minus-margin" [ngClass]="{ inactive: isInactive(mainKey) }">
                @for (key of order.other; track key) {
                  @if (key === '_timeslot') {
                    <div class="col-12 col-xl-4 form-field-container">
                      <mat-checkbox
                        class="checkbox"
                        [formControl]="getFormControl(mainKey + key)"
                        (change)="clearTimeslots(mainKey, $event.checked)"
                      >
                        {{ 'form.field.' + mainKey + key | transloco }}
                        <div
                          class="i-icon"
                          #tooltip="matTooltip"
                          [matTooltip]="'tooltip.shop.' + mainKey + key | transloco"
                          [matTooltipPosition]="'above'"
                          (click)="tooltip.toggle()"
                        >
                          <span class="i">i</span>
                        </div>
                      </mat-checkbox>
                    </div>
                  }
                  @if (key === '_timeslot_interval' && getFormControl(mainKey + '_timeslot').value) {
                    <div class="col-md-6 col-xl-4 form-field-container align-self-center">
                      <div class="form-field-label">
                        {{ 'form.field.timeslot_interval' | transloco }}
                      </div>
                      <lib-select
                        [options]="shopTimeSlots"
                        [value]="getFormControl(mainKey + key).value"
                        (valueChange)="getFormControl(mainKey + key).setValue($event)"
                      ></lib-select>
                    </div>
                  }
                  @if (key === '_timeslot_grace_period_minutes' && getFormControl(mainKey + '_timeslot').value) {
                    <div class="col-md-6 col-xl-4 form-field-container align-self-center">
                      <div class="form-field-label">
                        {{ 'form.field.' + mainKey + key | transloco }}
                      </div>
                      <mat-form-field class="form-field form-field-min" [floatLabel]="'auto'">
                        <span class="min">min</span>
                        <input matInput type="number" [formControlName]="mainKey + key" />
                      </mat-form-field>
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        }
        <div class="row">
          <div class="col-12 col-xl-auto col-main-checkbox form-field-container">
            <mat-checkbox
              class="checkbox"
              [formControl]="getFormControl('digital') | formControl"
              (change)="handleDigitalCostChange($event.checked)"
            >
              {{ 'form.field.' + 'digital' | transloco }}
            </mat-checkbox>
          </div>
        </div>
      </form>
    </div>
  }
</div>
